/** Plain cell value of a derived row. */
export type CellValue = string | number | boolean;

/** Column of a derived table: stable key, i18n label key and value accessor. */
export interface Column<R> {
  key: string;
  /** i18n key, `columns.<table>.<key>`. */
  labelKey: string;
  value: (row: R) => CellValue;
  /** Values are codes: shown as the i18n text `<enumKey>.<value>` (e.g. the mix kind). */
  enumKey?: string;
}

/** Columns that read `row[key]` directly, labelled `columns.<table>.<key>`. */
export function fieldColumns<R>(table: string, keys: ReadonlyArray<keyof R & string>): Column<R>[] {
  return keys.map((key) => ({
    key,
    labelKey: `columns.${table}.${key}`,
    value: (row: R) => row[key] as CellValue,
  }));
}
